<script>
    import {push} from "svelte-spa-router";
    import {data} from "../store";
    import {fade} from 'svelte/transition';
    import {onMount} from 'svelte';
    let etapa = 0;
    let esmenor=false;
    let datos = {};
    let dia,mes,ano;
    let fecha = new Date();

    onMount(()=>{
        if ($data.local == undefined || $data.local == ""){
            push('/');
        }
    })
    function siguiente(){
        let documento = {
            nombre: "Covid",
            fecha: fecha,
            texto:[
                "",
                "",
                "",
                "",
                ""
            ]
        }
        $data.respuestas.push(documento);

        if ($data.telefono != undefined && $data.telefono != ""){
            push("/servicio");
        }
    }
    function menor(){
        etapa = 4;
        $data.mayor = {fecha:{dia:undefined,mes:undefined,ano:undefined}};
        $data.fecha = {dia:undefined,mes:undefined,ano:undefined};
        esmenor=true;
    }
    function mayor(){
        if (esmenor) {
            if ($data.mayor.nombre != "" && $data.mayor.nombre != undefined){
                etapa = 1;
            }
        } else {
            etapa = 1;
        }
        $data.fecha = {dia:undefined,mes:undefined,ano:undefined};
    }
    function contacto(){
        if ($data.nombre != undefined && $data.nombre != ""){
            etapa = 2;
        }
    }
</script>
<div class="flex flex-col items-center justify-start w-full h-full p-4" in:fade="{{duration: 500}}">
    <div class="w-full grid grid-cols-3 grid-row-auto">
        <div class="flex items-center justify-center">
            <div class="w-8 h-8 bg-red-500 shadow text-white rounded-full flex items-center justify-center">1</div>
        </div>
        <div class="flex items-center justify-center">
            <div class="w-8 h-8 bg-white shadow rounded-full flex items-center justify-center">2</div>
        </div>
        <div class="flex items-center justify-center">
            <div class="w-8 h-8 bg-white shadow rounded-full flex items-center justify-center">3</div>
        </div>
    </div>
    <div class="w-full grid grid-cols-3 grid-row-auto text-xs text-center">
        <div class="flex flex-col items-center justify-start">
            Datos Personales
        </div>
        <div class="flex flex-col items-center justify-start">
            Servicio
        </div>
        <div class="flex flex-col items-center justify-start">
            Firma
        </div>
    </div>

    <div class="w-full flex flex-col items-center justify-start pt-8">
        {#if etapa == 0}
            <h1 class="w-full text-center text-xl font-bold mb-2">La persona que se va a realizar el servicio es...</h1>
            <div class="p-2 mb-2 rounded shadow bg-red-500 text-white flex items-center justify-center cursor-pointer hover:bg-red-300 w-full" on:click={menor}><span class="font-bold">Menor</span>&nbsp;de edad</div>
            <div class="p-2 mb-2 rounded shadow bg-red-500 text-white flex items-center justify-center cursor-pointer hover:bg-red-300 w-full" on:click={mayor}><span class="font-bold">Mayor</span>&nbsp;de edad</div>
        {:else if etapa == 1}
            <p in:fade="{{duration: 500}}">Nombre y Apellido{#if esmenor}&nbsp;del&nbsp;<span class="font-bold">menor</span>{/if}</p>
            <input bind:value={$data.nombre} placeholder="Ej: Juan Perez" type="text" class="m-2 p-2 w-full bg-white rounded shadow" in:fade="{{duration: 500}}"/>
            <p in:fade="{{duration: 500}}">DNI{#if esmenor}&nbsp;del&nbsp;<span class="font-bold">menor</span>{/if}</p>
            <input bind:value={$data.documento} placeholder="Ej: 31999999" type="tel" class="m-2 p-2 w-full bg-white rounded shadow" in:fade="{{duration: 500}}"/>
            <p in:fade="{{duration: 500}}">Fecha de Nacimiento{#if esmenor}&nbsp;del&nbsp;<span class="font-bold">menor</span>{/if}</p>
            <div class="flex items-center justify-center mt-2" in:fade="{{duration: 500}}">
                <input bind:value={$data.fecha.dia} placeholder="31" type="tel" class="p-2 w-1/3 bg-white rounded-l shadow" />
                <input bind:value={$data.fecha.mes} placeholder="01" type="tel" class="p-2 w-1/3 bg-white shadow" />
                <input bind:value={$data.fecha.ano} placeholder="1993" type="tel" class="p-2 w-1/3 bg-white rounded-r shadow" />
            </div>
            <div class="flex items-center justify-center mt-2 w-full" in:fade="{{duration: 500}}">
                <div on:click={contacto} class="p-2 rounded shadow bg-red-500 text-white flex items-center justify-center cursor-pointer hover:bg-red-300 w-full">Continuar</div>
            </div>
        {:else if etapa == 2}
            <p in:fade="{{duration: 500}}">Instagram (no obligatorio)</p>
            <input bind:value={$data.instagram} placeholder="Ej: JuanPerez" type="text" class="m-2 p-2 w-full bg-white rounded shadow" in:fade="{{duration: 500}}" />
            <p in:fade="{{duration: 500}}">Teléfono</p>
            <input bind:value={$data.telefono} placeholder="Ej:11 999999 (sin 15 ni 0)" type="tel" class="m-2 p-2 w-full bg-white rounded shadow" in:fade="{{duration: 500}}" />
            <div class="flex items-center justify-center mt-2 w-full" in:fade="{{duration: 500}}">
                <div on:click={siguiente} class="p-2 rounded shadow bg-red-500 text-white flex items-center justify-center cursor-pointer hover:bg-red-300 w-full" in:fade="{{duration: 500}}">Continuar</div>
            </div>
        {:else if etapa == 4}
        <p in:fade="{{duration: 500}}">Nombre y Apellido del&nbsp;<span class="font-bold">acompañante mayor</span></p>
        <input  bind:value={$data.mayor.nombre} placeholder="Ej: Juan Perez" type="text" class="m-2 p-2 w-full bg-white rounded shadow" in:fade="{{duration: 500}}" />
        <p in:fade="{{duration: 500}}">DNI del&nbsp;<span class="font-bold">acompañante mayor</span></p>
        <input bind:value={$data.mayor.documento} placeholder="Ej: 31999999" type="tel" class="m-2 p-2 w-full bg-white rounded shadow" in:fade="{{duration: 500}}" />
        <p in:fade="{{duration: 500}}">Vinculo con el&nbsp;<span class="font-bold">menor</span></p>
        <input bind:value={$data.mayor.vinculo} placeholder="Ej: Padre" type="text" class="m-2 p-2 w-full bg-white rounded shadow" in:fade="{{duration: 500}}" />
        <p in:fade="{{duration: 500}}">Fecha de Nacimiento del&nbsp;<span class="font-bold">acompañante mayor</span></p>
        <div class="flex items-center justify-center mt-2" in:fade="{{duration: 500}}">
            <input bind:value={$data.mayor.fecha.dia} placeholder="31" type="tel" class="p-2 w-1/3 bg-white rounded-l shadow" />
            <input bind:value={$data.mayor.fecha.mes} placeholder="01" type="tel" class="p-2 w-1/3 bg-white shadow" />
            <input bind:value={$data.mayor.fecha.ano} placeholder="1993" type="tel" class="p-2 w-1/3 bg-white rounded-r shadow" />
        </div>
        <div class="flex items-center justify-center mt-2 w-full" in:fade="{{duration: 500}}">
            <div on:click={mayor} class="p-2 rounded shadow bg-red-500 text-white flex items-center justify-center cursor-pointer hover:bg-red-300 w-full">Continuar</div>
        </div>
        {/if}
    </div>
</div>